import { Spin } from "antd";
import PropTypes from "prop-types";

import { FIELD_PREVIEW_DEFAULT_VALUE } from "@/components/Elements/FieldPreview/FieldPreview.constant";
import TextEllipsis from "@/components/Elements/TextEllipsis";

import { MaterialFieldItem } from "./MaterialFieldPreview.type";

// Can be used to display `material` and `defect` value
const MaterialFieldPreview = ({ value, loading }) => {
  if (loading)
    return (
      <span role="status">
        <Spin size="small" />
      </span>
    );

  if (!value) return FIELD_PREVIEW_DEFAULT_VALUE;

  if (typeof value === "string") return <TextEllipsis>{value}</TextEllipsis>;

  return <TextEllipsis>{value.name}</TextEllipsis>;
};

MaterialFieldPreview.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, MaterialFieldItem]),
  loading: PropTypes.bool,
};

export default MaterialFieldPreview;
